// @flow

import { HOST } from 'common/constants/foxford'
import { FoxfordService } from 'services/foxford'

export const assignToTest = async ($btn: JQuery) => {
  const course = $btn.data('course')

  if ($btn.hasClass('disabled') || course === 0) {
    return
  }

  await FoxfordService.user.pushEvent({ action: 'conversion', label: 'test' })

  window.location.assign(`${HOST}/trainings/${course}`)
}
